export interface EnvironmentConfig {
  API_URL: string;
  ENVIRONMENT: string;
  IS_PRODUCTION: boolean;
  IS_DEVELOPMENT: boolean;
  IS_HOMOLOGATION: boolean;
}

function detectEnvironment(): 'development' | 'production' | 'homologation' {
  // Verifica variável de ambiente do Vite
  if (import.meta.env.VITE_ENVIRONMENT) {
    return import.meta.env.VITE_ENVIRONMENT as 'development' | 'production' | 'homologation';
  }

  // Verifica se está em produção baseado no hostname
  const hostname = window.location.hostname;

  if (hostname.includes('dev-maturidade')) {
    return 'development';
  }

  if (hostname.includes('hm-maturidade') || hostname.includes('homolog')) {
    return 'homologation';
  }

  if (hostname.includes('sebrae-mg.com.br') || hostname.includes('sebraemg.com.br')) {
    return 'production';
  }

  return 'development';
}

export function getEnvironmentConfig(): EnvironmentConfig {
  const environment = detectEnvironment();

  switch (environment) {
    case 'development':
      const isCloudDev = window.location.hostname.includes('dev-maturidade');
      return {
        API_URL: isCloudDev
          ? 'https://dev-api-maturidadedigital.sebraemg.com.br/api'
          : (import.meta.env.VITE_DEVELOPMENT_API_URL || '/api'),
        ENVIRONMENT: 'development',
        IS_PRODUCTION: false,
        IS_DEVELOPMENT: true,
        IS_HOMOLOGATION: false,
      };

    case 'production':
      return {
        API_URL: import.meta.env.VITE_PRODUCTION_API_URL || '/api',
        ENVIRONMENT: 'production',
        IS_PRODUCTION: true,
        IS_DEVELOPMENT: false,
        IS_HOMOLOGATION: false,
      };

    case 'homologation':
      return {
        API_URL: import.meta.env.VITE_DEVELOPMENT_API_URL || '/api',
        ENVIRONMENT: 'homologation',
        IS_PRODUCTION: false,
        IS_DEVELOPMENT: false,
        IS_HOMOLOGATION: true,
      };

    default:
      return {
        API_URL: '/api',
        ENVIRONMENT: 'development',
        IS_PRODUCTION: false,
        IS_DEVELOPMENT: true,
        IS_HOMOLOGATION: false,
      };
  }
}